import AdminConfig from './admin';

import ClientView from './client';


export default {
  name : 'sendsms',

  type : 'module',
  
  label: 'envoi de SMS',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-map',
  }
}